export default "__VITE_ASSET__DaMlHWzd__"